import styled from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';
import { AlertButton, AlertContent } from 'components/tools/alerts/Alerts.styles';

export const Container = styled.div`
  margin-top: 20px;
  padding: 14px 26px 12px 32px;
  overflow: hidden;
  background-color: ${colors.lightGray14};
  animation-name: fadeIn;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  opacity: 0%;
  word-break: break-word;

  @keyframes fadeIn {
    0% {
      opacity: 0%;
    }
    100% {
      opacity: 100%;
    }
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  align-items: start;
`;

export const IconWrapper = styled.div`
  padding-top: 6px;
`;

export const TypeIcon = styled.img`
  margin-right: 10px;
`;

export const Flex = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
`;

export const EscalationMarker = styled.span`
  margin-right: 5px;
  color: ${colors.red2};
  font-family: 'Roboto', sans-serif;
  font-size: 11px;
  font-weight: 500;
`;

export const Content = styled(AlertContent)`
  margin: 0;
`;

export const ButtonWrapper = styled.div`
  padding-bottom: 7px;
  padding-left: 12px;
`;

export const EscalateButton = styled(AlertButton)`
  min-width: 75px;
  padding: 7px 10px;
  font-size: 11px;
  font-weight: 500;
`;
